<template>
    <div class="footer" :style="{background:$store.state.app.footerColor}">
        <div class="content">
            <div class="left">
                <div class="navList">
                    <div class="item" v-for="(item,index) in navList" :key="index" @click.stop="onPath(item.path)">{{item.name}}</div>
                </div>
                <div class="danwei">
                    <div class="item">指导单位：中共甘肃省委宣传部</div>
                    <div class="item">运行管理：丝绸之路国际知识产权港有限责任公司</div>
                </div>
                <div class="beian">
                    <div class="item">备案序号：陇ICP备 19003396号-2</div>
                    <div class="item">
                        <img class="img" src="./images/gan.png" alt="">
                        <div>甘公网安备 62010202001486号</div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="imgBox">
                    <div class="item">
                        <img class="img" src="./images/ewm.png" alt="">
                        <div>甘肃版权服务</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeFooter",
        data(){
            return {
                navList: [
                    {
                        name: "首页",
                        path: '/'
                    },
                  
                    {
                        name: "版权登记",
                        path: '/gananCopyrightRegistration'
                    },
                    {
                        name: "版权服务",
                        path: '/gananElectronic',
                        children: [
                            {
                                name: '电子数据存证',
                                path: '/gananElectronic'
                            },
                            {
                                name: '版权区块链存证',
                                path: '/gananPreRegistration'
                            },
                            {
                                name: '软件著作权登记',
                                path: '/gananSoftwareCopyright'
                            },
                            {
                                name: '版权监测',
                                path: '/gananCopyrightMonitoring'
                            },
                            {
                                name: '版权维权',
                                path: '/gananCopyrightRights'
                            },
                            {
                                name: '网页取证',
                                path: '/gananWebForensics'
                            }
                        ],
                    },
                    {
                        name: "IP授权",
                        path: '/gananIpAuth'
                    },
                    {
                        name: "新闻资讯",
                        path: '/gananNewCenter'
                    },
                    {
                        name: "验证中心",
                         path: '/gananAuthenticationCenter'
                    },
                   
                    {
                        name: "关于我们",
                        path: '/gananAboutUs'
                    },
                ],
            }
        },
        methods: {
            onPath(path) {
                if (path) {
                    this.$router.push(path)
                }
            },
        },
        watch: {
            $route(to, from) {

            }
        }
    };
</script>

<style lang="less" scoped>
.footer{
    background: #fff;
    .content{
        display: flex;
        align-items: center;
        height: 208px;
        max-width: 1200px;
        margin: auto;
        .left{
            flex: 1;
            .navList{
                display: flex;
                align-items: center;
                .item{
                    font-size: 16px;
                    color: #333333;
                    position: relative;
                    padding: 0 20px;
                    cursor: pointer;
                    font-family: 'AlibabaPuHuiTi';
                    &:first-child{
                        padding-left: 0;
                    }
                    &:last-child{
                        padding-right: 0;
                        &::after{
                            content:  '';
                            display: none;
                        }
                    }
                    &::after{
                        content:  '';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        height: 50%;
                        background: #333;
                        width: 1px;
                        transform: translate(0,-50%);
                    }
                }
            }
            .danwei{
                display: flex;
                align-items: center;
                margin-top: 37px;
                margin-bottom: 15px;
                .item{
                    font-size: 14px;
                    color: #999;
                    margin-right: 32px;
                    display: flex;
                    align-items: center;
                    .img{
                        width: 20px;
                        height: 20px;
                        margin-right: 4px;
                    }
                }
            }
            .beian{
               display: flex;
                align-items: center;
                margin-top: 15px;
                .item{
                    font-size: 14px;
                    color: #999;
                    margin-right: 32px;
                    display: flex;
                    align-items: center;
                    .img{
                        width: 20px;
                        height: 20px;
                        margin-right: 4px;
                    }
                } 
            }
        }
        .right{
            .imgBox{
                display: flex;
                .item{
                    font-size: 12px;
                    color: #999999;
                    text-align: center;
                    .img{
                        width: 112px;
                        height: 112px;
                        margin-bottom: 8px;
                    }
                }
            }
        }
    }

}
</style>
